import sensors from "sa-sdk-javascript";
export function pushSensorsInit(userId, data = {
    user_type: '',
    user_level: '',
    lolatitude: '',
    nick_name: ''
}) {
    try {
        let parameter = {
            platformType: "H5",
            platformName: "MRYTH5",
            DownloadChannel: "mryt",
            // user_type: '',
            // user_level: '',
            // lolatitude: '',
            // share_id
            ...data
        }
        sensors.init({
            //heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
            //web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
            sdk_url: "https://cdn.jsdelivr.net/npm/sa-sdk-javascript@1.14.5/sensorsdata.min.js",
            heatmap_url: "https://cdn.jsdelivr.net/npm/sa-sdk-javascript@1.14.5/heatmap.min.js",
            name: "sensors",
            use_app_track: true,
            //   server_url: window.location.host==='h5-mall.mryitao.cn'?"https://shence.mryitao.cn/sa?project=new_production":'https://shence.mryitao.cn/sa?project=default',
            server_url: 'https://shence.mryitao.cn/sa?project=new_production',
            ...parameter,
            heatmap: {
                //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
                //需要 JSSDK 版本号大于 1.7
                clickmap: "default",
                //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
                //需要 JSSDK 版本号大于 1.9.1
                scroll_notice_map: "not_collect",
            }
        })
        sensors.registerPage(parameter)
        if(userId){
            sensors.login(userId);
        }
        sensors.quick("autoTrack");
    } catch (error) {

    }
}



// WEBPACK FOOTER //
// ./src/utils/sensors.js